import './styles.scss';
import { AlertStyled } from './styles';
import { BottomErrorBarProps } from './types';
import { ReactComponent as WarningIcon } from '../../assets/icons/ContractErrorIcon.svg';

const BottomErrorBar = (props: BottomErrorBarProps): JSX.Element => {
  const { message, onClose } = props;

  return (
    <AlertStyled severity="error" icon={false} onClose={onClose}>
      <WarningIcon className="error-warning-icon" />
      <div>{message}</div>
    </AlertStyled>
  );
};

BottomErrorBar.defaultProps = {
  onClose: undefined,
};

export default BottomErrorBar;
